import { render, staticRenderFns } from "./generations.vue?vue&type=template&id=648633a2&"
import script from "./generations.vue?vue&type=script&lang=js&"
export * from "./generations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports